export const INN_INDIVIDUAL_LENGTH = 12;
export const INN_LEGAL_ENTITY_LENGTH = 10;
export const MIN_OGRNIP_LENGTH = 13;
export const MAX_OGRNIP_LENGTH = 15;
export const SNILS_LENGTH = 11;
export const KPP_LENGTH = 9;
export const MIN_REGISTRATION_LENGTH = 17;